export default __webpack_public_path__ + "assets/images/3c1b3d40421484ab6c151c080e07a1d9.png";